import { isPresent } from 'utils/isPresent';

import URL_PATHS from 'components/Settings/SettingsV2/SettingsPaths';
import url from 'components/url';

import { CreditCard } from './Billing/types';

const INVOICE_MESSAGES_PLACEHOLDER = '(Optional)';
const TERMS_AND_CONDITIONS_PLACEHOLDER =
  "Enter any terms and conditions of a customer's purchase. You can include legal terms, warranty, etc. When included, terms will appear as a link that can be viewed at customer sign-off.";
const DESCRIPTION_PLACEHOLDER = 'Enter a short description of your business';

const SETTINGS_PAGE_REDIRECTS: { [key: string]: string } = {
  [url.map.path]: URL_PATHS.service_area.root,
  [url.inbox.calls.path]: URL_PATHS.voice.phone_numbers,
  [url.inbox.customers.path]: URL_PATHS.text_messages.root,
  [url.jobs.path]: URL_PATHS.job_details.job_fields,
  [url.jobsListView.path]: URL_PATHS.job_details.job_fields,
  [url.estimates.path]: URL_PATHS.estimates.customer_view,
  [url.estimatesListView.path]: URL_PATHS.estimates.customer_view,
  [url.timeSheet.path]: URL_PATHS.time_tracking.root,
  [url.pipeline.path]: URL_PATHS.pipeline.automations,
  [url.customersListView.path]: URL_PATHS.lead_source.root,
  [url.quickbooks.path]: URL_PATHS.quickbooks_online.sync_alerts,
};

export const formatEmptyData = (data: Nullable<string>) => (isPresent(data) ? data : '-');

export const formatEmptyLogo = (logo: string) => (logo.endsWith('/assets/blank.gif') ? '' : logo);

export const formatEmptyInvoiceMessage = (message: string) =>
  isPresent(message) ? message : INVOICE_MESSAGES_PLACEHOLDER;

export const formatEmptyTerms = (terms: string) => (isPresent(terms) ? terms : TERMS_AND_CONDITIONS_PLACEHOLDER);

export const formatEmptyDescription = (description: string) =>
  isPresent(description) ? description : DESCRIPTION_PLACEHOLDER;

const getBaseUrl = (currentPath: string): string => {
  if (currentPath.includes(url.jobs.path)) return url.jobs.path;
  if (currentPath.includes(url.estimates.path)) return url.estimates.path;
  if (currentPath.includes(url.timeSheet.path)) return url.timeSheet.path;
  if (currentPath.includes(url.pipeline.path)) return url.pipeline.path;
  if (currentPath.includes(url.quickbooks.path)) return url.quickbooks.path;

  return currentPath;
};

export const getSettingsPath = (): string => {
  const currentPath = window.location.pathname;
  const baseUrl = getBaseUrl(currentPath);

  return SETTINGS_PAGE_REDIRECTS[baseUrl] ?? URL_PATHS.profile.root;
};

export const formatBillingInfo = (creditCard: CreditCard | undefined, isSubscribed: boolean | undefined) => {
  const billingInfo = {
    expiry: creditCard?.expiredDate,
    name_on_card: creditCard?.nameOnCard,
    payment_method: creditCard ? `${creditCard.brand} ending in ${creditCard.last4}` : undefined,
    is_in_app_subscription: isSubscribed,
  };

  return billingInfo;
};
